import { useRef, useEffect, useState, MutableRefObject } from 'react';
import { escape } from '../utils/shared.utils';

export function useSetInputWidthByContent(
    minInputWidth,
    maxInputWidth,
    fieldStyleForHiddenSpan,
    idForHiddenSpan
): [MutableRefObject<HTMLInputElement>, boolean, number] {
    const inputRef = useRef<HTMLInputElement>(null);
    const [isEllipsisActive, setIsEllipsisActive] = useState<boolean>(false);
    const [inputWidth, setInputWidth] = useState(minInputWidth);

    let hiddenSpan = document.querySelector(
        `#${idForHiddenSpan}`
    ) as HTMLSpanElement;

    // This is a hidden span in order to claculate width of input content
    if (!hiddenSpan) {
        hiddenSpan = document.createElement('span');
        hiddenSpan.setAttribute('style', fieldStyleForHiddenSpan);
        hiddenSpan.id = 'flow-title-hidden-span';
        document.querySelector('body').append(hiddenSpan);
    }

    useEffect(() => {
        if (!inputRef.current) {
            setIsEllipsisActive(false);
        } else {
            hiddenSpan.innerHTML = escape(inputRef.current.value);
            if (hiddenSpan.offsetWidth < maxInputWidth) {
                setInputWidth(hiddenSpan.offsetWidth + 10);
                setIsEllipsisActive(false);
            } else {
                setInputWidth(maxInputWidth);
                setIsEllipsisActive(
                    inputRef.current.scrollWidth > inputRef.current.offsetWidth
                );
            }
        }
    }, [inputRef.current?.value, hiddenSpan, maxInputWidth]);

    return [inputRef, isEllipsisActive, inputWidth];
}
